import React from "react";
import { Plus, ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { KIND_LABEL } from "@/components/shownotes/meta";

// "New notes" → pick the Rehearsal or Show template.
export default function NewNotesButton({ onPick }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button className="rounded-full bg-slate-900 hover:bg-slate-800" data-testid="notes-new-btn">
          <Plus className="mr-2 h-4 w-4" /> New notes <ChevronDown className="ml-1 h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {Object.entries(KIND_LABEL).map(([k, label]) => (
          <DropdownMenuItem key={k} onClick={() => onPick(k)} data-testid={`notes-new-${k}`}>{label}</DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
